// extracted by mini-css-extract-plugin
export var standaloneTable = "_ed-0";
export var standaloneTableWithBodyFill = "_ed-1";
export var withExtraHeader = "_ed-2";